'use client'

import { ReactNode } from 'react'

import { useFeatures } from '@/src/hooks/useFeatures'
import type { Features } from '@/src/utils/featureConfig'

type FeatureRendererProps = {
    children: ReactNode | ReactNode[] | null
    type: keyof Features
}

// Reads the per-host feature set (build-time brand + theme overlay) rather than
// featureConfig[VARIANT], so sub-brands like heya can switch a section off.
const FeatureRenderer = (props: FeatureRendererProps) => {
    const { children, type } = props
    const features = useFeatures()
    return features?.[type] ? <>{children}</> : <></>
}

export default FeatureRenderer
